import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { privateGet } from 'services/privateRequest';
import { FORM_RESPONSE } from 'services/apiEndpoints';
import toast from 'react-hot-toast';
import ReportsTable from '../reports/ReportsTable';
import styles from "../reports/SingleReportsDetails.module.scss"
import DrawerAppBar from 'components/sharedappbar/SharedAppBar';
const ShareReport = () => {
    const { id, formName } = useParams();
    const [data, setData] = useState({});
    const [loader, setLoader] = useState(false);

    const fetchData = async () => {
        try {
            setLoader(true);
            const response = await privateGet(`${FORM_RESPONSE}/${id}`);
            const responseData = response?.data?.data;
            setData(responseData);
            setLoader(false);
        } catch (err) {
            setLoader(false);
            toast?.error(err?.message);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        // <div className={styles.emailContainer}>
        //     <div className={styles.emailBox}>
        //         <table>
        //             <tbody>
        //                 <tr>
        //                     <td colSpan="3">
        //                         <h1>{data.name}</h1>
        //                     </td>
        //                 </tr>
        //                 <tr>
        //                     <td>
        //                         <h3>Northwoods Apartments</h3>
        //                         <p>23925 Eucalyptus Ave<br />Moreno Valley, CA 92553</p>
        //                     </td>
        //                     <td></td>
        //                     <td>
        //                         <h3>Alex Chavez</h3>
        //                         <p>Submitted January 3, 2025 1:13 PM (PST)</p>
        //                     </td>
        //                 </tr>
        //                 <tr>
        //                     <td colSpan="3"><h2>Matching Triggers</h2></td>
        //                 </tr>
        //                 <tr>
        //                     <td colSpan="3"><strong>• RR Audit</strong></td>
        //                 </tr>
        //                 <tr>
        //                     <td colSpan="3"><h2>Follow-Up Tasks</h2></td>
        //                 </tr>
        //                 <tr>
        //                     <td colSpan="3">
        //                         <a href={data.link} className={styles.taskLink}>RR Audit</a>
        //                         <strong>Due on Sun, Jan 5</strong>
        //                     </td>
        //                 </tr>
        //                 {data?.fields?.length > 0 && (
        //                     <>
        //                         <tr>
        //                             <td><h2>Submission</h2></td>
        //                         </tr>
        //                         {data.fields.map((field, i) => (
        //                             <tr key={field.fieldId} className={i % 2 === 0 ? styles.rowAlt : ''}>
        //                                 <td>{field.label.replace(':', '')}:</td>
        //                                 <td>
        //                                     {field?.value?.length > 0
        //                                         ? field.value.map((val, i) => (i === 0 ? <b key={i}>{val}</b> : <br key={i} />))
        //                                         : ''}
        //                                 </td>
        //                             </tr>
        //                         ))}
        //                     </>
        //                 )}
        //             </tbody>
        //         </table>
        //     </div>
        // </div>
        <>
            <div style={{ background: "rgb(248, 244, 244)" }}>
                <DrawerAppBar />


                <h2 style={{ textAlign: "center", padding: "10px" }}>{formName}</h2>
                <div className={styles?.mainSingleReport} style={{ display: "flex", justifyContent: "center" }}>

                    <ReportsTable data={data} loader={loader} share={true} />
                </div>
            </div>
        </>
    );
};

export default ShareReport;
